import React from 'react';
import PropTypes from 'prop-types';
import { displayUserName } from '../../../../services/utilityFunctions';
import UserProp from '../../../../commonComponents/propTypes/userProp';

export default function RankingItem({ user1, user2 }) {
  const getImageFromUser = (user, mood) => {
    if (user.mood && user.mood[mood]) {
      return user.mood[mood];
    }
    if (user.image) {
      return user.image.thumb ? user.image.thumb : '/images/no_user.png';
    }
    return '/images/no_user.png';
  };

  return (
    <div className="ranking-container">
      <div className="ranking-user-left">
        <img
          className="ranking-user-thumb-left"
          src={getImageFromUser(user1, 'happy')}
          alt="user avatar"
        />
        {displayUserName(user1, true)}
        <img
          className="ranking-user-arrow"
          alt="up arrow"
          src="/images/up-position.png"
        />
      </div>

      <div className="ranking-user-right">
        <img
          className="ranking-user-arrow"
          alt="down arrow"
          src="/images/down-position.png"
        />
        {displayUserName(user2, true)}
        <img
          className="ranking-user-thumb-right"
          src={getImageFromUser(user2, 'unhappy')}
          alt="user avatar"
        />
      </div>
    </div>
  );
}

RankingItem.propTypes = {
  user1: PropTypes.shape(UserProp.propType).isRequired,
  user2: PropTypes.shape(UserProp.propType).isRequired,
};
